import { render, staticRenderFns } from "./JdsNavigatorItemGroup.vue?vue&type=template&id=d0f7b780&scoped=true&"
import script from "./JdsNavigatorItemGroup.vue?vue&type=script&lang=ts&"
export * from "./JdsNavigatorItemGroup.vue?vue&type=script&lang=ts&"
import style0 from "./JdsNavigatorItemGroup.vue?vue&type=style&index=0&id=d0f7b780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f7b780",
  null
  
)

export default component.exports